import { Col, Row, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import { getUserStatus } from "../../../models/user/enum";
import { getBannerType } from "../../../models/banner-screen/enum";
import CategoryContext from "../../../context/category/context";
import BannerCategoryContext from "../../../context/banner-achievements-screen/context";
interface IProps { }

const BannerCategoryFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(BannerCategoryContext);
  const { allCategories } = useContext(CategoryContext);
  const statuses = [1, 2];

  return (
    <Form
      formId="category-banner-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.category_id
              ? {
                name: "category_id",
                value: data.category_id,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col span={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statuses.map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col span={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2, 3, 4, 5].map((status, index) => {
                return {
                  label: t(getBannerType(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default BannerCategoryFilter;
